/* eslint-disable prettier/prettier, react/prop-types */
import { Spin } from 'antd';
import React, { Suspense } from 'react';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin flex items-center justify-center h-[calc(100vh-132px)]">
            <Spin />
          </div>
        }
      >
        <div
          style={{ backgroundImage: `url("${require('../../../static/img/login-bg.jpg')}")` }} 
          className="bg-top bg-no-repeat h-screen bg-cover"
        >
          <div className="px-[15px] flex flex-col justify-center h-full">
            <div className="flex justify-center">
              <img className=" h-14 dark:hidden" src="/logo.png" alt="" />
              <img className=" h-14 hidden dark:block" src="/logo.png" alt="" />
            </div>
            <WraperContent />
          </div>
        </div>
      </Suspense>
    );
  };
};

export default AuthLayout;
